export default {
  endpoints: {
    stitchBackend: "https://api.sandbox.withstitch.com",
  },
  debug: false,
};
